import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

interface MetricStatProps {
  label: string;
  value: string | number;
  suffix?: string;
  /** Ícone opcional ao lado do rótulo — não afeta quem não passa a prop. */
  icon?: LucideIcon;
  className?: string;
}

export function MetricStat({ label, value, suffix, icon: Icon, className }: MetricStatProps) {
  // Números e valores curtos (%, contagens) ganham o tamanho "hero" de
  // 30px do design system; strings mais longas (nome de jogo/música) usam
  // um tamanho menor pra não estourar/quebrar linha num card estreito.
  const isLong = typeof value === 'string' && value.length > 12;

  return (
    <div className={cn('space-y-1', className)}>
      <p className="flex items-center gap-1.5 text-xs text-muted-foreground font-medium">
        {Icon && <Icon className="h-3.5 w-3.5 text-primary shrink-0" />}
        {label}
      </p>
      <p
        className={cn(
          'font-bold text-foreground tabular-nums leading-tight tracking-tight',
          isLong ? 'text-lg' : 'text-[30px] leading-none'
        )}
      >
        {typeof value === 'number' ? value.toLocaleString('pt-BR') : value}
        {suffix && (
          <span className="text-sm font-normal text-muted-foreground ml-1">
            {suffix}
          </span>
        )}
      </p>
    </div>
  );
}
